// @flow
import type {
  GetFetchOptionsComposerArgs,
  GetFetchOptionsArgs,
  GetFetchOptionsResult,
  GetFetchOptions,
} from '../../types'

// Constants
import {
  GET,
  POST,
  PUT,
} from '../constants'

// Effect Managers
import { call } from 'redux-saga/effects'

// Export
export default function composeGetOptions ({getTokenSaga}: GetFetchOptionsComposerArgs): GetFetchOptions {
  return function *fetchOptions ({
    type = GET,
    options = {},
    asFormData = false,
    excludeToken = false,
    token: maybeToken,
    }: GetFetchOptionsArgs = {}): GetFetchOptionsResult {
    //
    const token: ?string = yield maybeToken || call(getTokenSaga)

    const headers: Object = excludeToken || !token ? {} : { 'Authorization': `Token ${token}` }

    if ((type === POST || type === PUT) && !asFormData) {
      headers['Content-Type'] = 'application/json'
    }

    return {
      headers,
      method: type,
      ...options,
    }
  }
}
